

































































































import SimpleMap from '../../core/components/SimpleMap.vue';
import Input from '../../core/components/Input.vue';
import Button from '../../core/components/Button.vue';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import { MsgBox, Combobox, PlusEyeButtons, Breadcrums, CloseConfirmationModal } from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';

@Component({
    components: {
        Input,
        Loading,
        SimpleMap,
        Combobox,
        Button,
        DeleteConfirmation
    }
})
export default class ModalNewPolicy extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop({default: true}) canDelete: boolean;
    @Prop() patchData: object | null;
    @Prop() harvestId: object | null;
    //    @Prop() noteTypes: Array<object>;

    modalTitle: string = '';
    policyName: string = '';
    securedArea: string = '';
    errorMsg: string = '';
    currentAction: string = '';

    //delete modal
    confirmationDelete: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';

    showLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    showSuccessLoadingDialog(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg
        });
    }
    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    setErrorMsg(msg) {
        this.errorMsg = msg;
    }
    updateSecuredArea(value) {
        this.securedArea = value;
    }
    updatePolicyName(value) {
        this.policyName = value;
    }

    submitPolicy() {
        let formData = this.getData;
        // console.log('formData', formData);
        if (this.patchData == null) {
            // console.log('post poliza');
            this.showLoadingDialog('Guardando Poliza...');
            this.postPolicy(formData);
        } else {
            this.showLoadingDialog('Modificando Poliza...');
            this.patchPolicy(formData);
        }
    }

    postPolicy(formData) {
        this.currentAction = 'post';
        let self = this;
        InsuranceServices.postPolicy(formData)
            .then(res => {
                let msg = res['message'] !== undefined ? res['message'] : 'Poliza creada con éxito';
                self.showSuccessLoadingDialog(res, msg);
                setTimeout(() => {
                    self.$emit('add-new-policy', res['new_policy']);
                    self.closeModal();
                }, 1000);
            })
            .catch(err => {
                self.showCatchLoadingDialog(err, 'No se pudo crear la poliza');
            });
    }

    patchPolicy(formData) {
        this.currentAction = 'patch';
        let self = this;
        let id = this.patchData !== null ? this.patchData['id'] : null;
        if (id !== null) {
            InsuranceServices.patchPolicy(id, formData)
                .then(response => {
                    self.showSuccessLoadingDialog(response.data, 'Poliza modificada correctamente');
                    setTimeout(() => {
                        self.$emit('update-policy', response['data']['policy']);
                        self.closeModal();
                    }, 1000);
                })
                .catch(err => {
                    self.showCatchLoadingDialog(err, 'Ocurrio un error');
                });
        }
    }

    get getData() {
        return {
            number: this.policyName,
            secured_area: this.securedArea === '' || this.securedArea == null ? 0 : Number(this.securedArea),
            harvest: Number(this.harvestId)
        };
    }

    get formIsValid() {
        this.setErrorMsg('');
        if (this.policyName === '' || this.policyName == null) {
            this.setErrorMsg('Debe ingresar un nombre');
            return false;
        }
        return true;
    }

    @Emit()
    closeModal() {}

    mounted() {
        this.loadPatchData();
    }

    get isPatch() {
        return this.patchData !== null ? true : false;
    }

    loadPatchData() {
        if (this.isPatch && this.patchData !== null) {
            this.modalTitle = 'Modificar Poliza <b>' + this.patchData['number'] + '</b>';
            this.updatePolicyName(this.patchData['number']);
            this.updateSecuredArea(this.patchData['secured_area']);
        } else {
            this.modalTitle = 'Nueva Poliza';
        }
    }

    deletePolicy() {
        if (this.patchData !== null) {
            this.deleteModalTitle = 'Eliminar Poliza';
            this.deleteBody =
                '¿Está seguro que desea eliminar la Poliza ' + '<b>"' + this.patchData['number'] + '"</b>?';
            this.confirmationDelete = true;
        }
    }

    deleteAction(value) {
        let self = this;
        if (value) {
            this.confirmationDelete = false;

            if (this.patchData !== null) {
                this.currentAction = 'delete';
                let policyId = this.patchData['id'];
                this.showLoadingDialog('Eliminando póliza');
                InsuranceServices.deletePolicy(policyId)
                    .then(response => {
                        this.showSuccessLoadingDialog(response.data, 'Poliza eliminada con éxito');
                        setTimeout(() => {
                            self.$emit('remove-policy-from-list', policyId);
                            self.closeModal();
                        }, 1000);
                    })
                    .catch(err => {
                        this.showCatchLoadingDialog(err, 'No se pudo eliminar la poliza');
                    });
            }
        } else {
            this.currentAction = '';
            this.confirmationDelete = false;
        }
    }
}
